<template>
  <div class="vid-res-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input v-model="searchTitle" placeholder="请输入标题" size="small" class="param-input" clearable></el-input>
      <el-input v-model="params.tag_text" placeholder="请输入标签" size="small" class="param-input" clearable></el-input>
      <el-input v-model="searchHashId" placeholder="请输入HashID" size="small" class="param-input" clearable></el-input>
      <el-input v-model="searchUpId" placeholder="请输入UP主ID" size="small" class="param-input" clearable></el-input>
      <el-select v-model="params.mVia" size="small" placeholder="请选择作者类型">
        <el-option v-for="(item, i) in mViaList" :value="item.value" :label="item.label" :key="i"></el-option>
      </el-select>
      <el-select v-model="params.videoType" size="small" placeholder="请选择视频类型">
        <el-option v-for="(item, i) in videoTypes" :value="item.value" :label="item.label" :key="i"></el-option>
      </el-select>
      <el-select v-model="params.syncType" size="small" clearable placeholder="请选择同步类型">
        <el-option v-for="(item, i) in syncTypes" :value="item.value" :label="item.label" :key="i"></el-option>
      </el-select>
      <el-select v-model="params.sortType" size="small" clearable placeholder="请选择排序类型">
        <el-option v-for="(item, i) in sortTypes" :value="item.value" :label="item.label" :key="i"></el-option>
      </el-select>
      <el-select v-model="params.maxTotal" size="small" clearable placeholder="列表最大总数">
        <el-option v-for="(item, i) in maxTotalTypes" :value="item.value" :label="item.label" :key="i"></el-option>
      </el-select>
      <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" format size="small"></el-date-picker>
      <el-button type="primary" size="small" @click="getList()">搜索</el-button>
      <el-button type="primary" size="small" @click="openSelection" :disabled="isDisabled">批量操作</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%;" max-height="800px" border v-loading="loading"
      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable"
      @sort-change="handleSortChange" @selection-change="handleSelectionChange">
      <el-table-column type="selection" v-if="isSelection" width="55" fixed="left" align="center">
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="240" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="视频内容" align="center" width="280">
        <template slot-scope="scope">
          <span>{{ scope.row.content || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="富文本预览" align="center" width="100">
        <template v-slot="{ row: { rich_text } }">
          <el-button :disabled="!rich_text" icon="el-icon-view" size="small" :type="rich_text ? 'success' : 'info'" @click="previewRich(rich_text)">预览</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="120"></el-table-column>
      <el-table-column prop="vlogger_user_id" label="UP主ID" align="center" min-width="120"></el-table-column>
      <el-table-column prop="tagList" label="标签" align="center" min-width="400">
        <template slot-scope="scope">
          <el-tag size="middle" type="success" class="tagItem" v-for="(item, index) in scope.row.tagList"
            :key="index">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="hash_id" label="hashId" align="center" min-width="200"></el-table-column>
      <el-table-column prop="sale_coin" label="售卖金币" align="center" min-width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.sale_coin || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="200" prop="cover">
        <template slot-scope="scope">
          <img-load :width="'80px'" :height="'60px'" :src="checkUrl(scope.row.cover_image) + scope.row.cover_image">
          </img-load>
        </template>
      </el-table-column>
      <el-table-column prop="pics" label="图集预览" align="center" width="110">
        <template slot-scope="scope">
          <div class="picturePreview" @click="previewPicture(scope.row.pics.split(','))">
            <decrypt-img style="width: 50px; height: 50px" :src="imgUrl + item" :iPreviewSrcList="[]" fit="fill"
              v-for="(item, i) in scope.row.pics.split(',')" :key="i"></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="视频审查" align="center" width="100">
        <template slot-scope="scope" v-if="scope.row.src_480 || scope.row.src_720 || scope.row.src_1080">
          <i class="el-icon-video-play views" title="点击预览" @click="
            checkMedia(
              scope.row.src_480 || scope.row.src_720 || scope.row.src_1080,
              scope.row
            )
            "></i>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <div class="bottom">
      <div class="btn" v-if="isSelection">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="success" size="mini" @click="useVideo">使用</el-button>
        <el-button type="primary" size="mini" @click="neglectVideo">忽略</el-button>
      </div>
      <div v-else></div>
      <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10"
        @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    </div>
    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>

    <el-dialog title="媒体使用" align="center" :visible.sync="showVidUse" width="650px" @close="close">
      <el-form ref="form" label-width="80px">
        <el-form-item label="作者ID:" prop="authorID">
          <el-input v-model="authorID" size="small" placeholder="请输入作者ID"></el-input>
        </el-form-item>
        <el-form-item label="视频权限" prop="permission">
          <el-select v-model="permission" placeholder="请选择视频权限" size="small" clearable>
            <el-option v-for="(type, index) in videoPermissionTypes" :key="index" :label="type.label"
              :value="type.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格:" prop="authorID">
          <el-input v-model.number="coin" size="small" placeholder="请输入价格"></el-input>
        </el-form-item>
        <el-form-item label="审核时间:" prop="reviewAt">
          <el-date-picker v-model="reviewAt" type="datetime" :editable="false" placeholder="请选择审核时间"
            size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="父专题:">
          <el-select v-model="searchSectionId" placeholder="请选择父专题" size="small" clearable
            @change="searchSelectSection">
            <el-option v-for="(section, index) in sections" :key="index" :label="section.moduleName"
              :value="section.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子专题:">
          <el-select v-model="searchSubSectionId" placeholder="请选择子专题" size="small" clearable>
            <el-option v-for="(subSection, index) in searchSubSections" :key="index" :label="subSection.sectionName"
              :value="subSection.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="UP主ID:" prop="vlogger_user_id">
                    <el-input v-model="vloggerUserId" size="small" placeholder="请输入作者ID"></el-input>
                </el-form-item> -->
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tags">
            <tag-selector v-model="tags" :tagList="tagList"></tag-selector>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBtn" size="small">取 消</el-button>
        <el-button @click="useMedia" type="primary" size="small">确 认</el-button>
      </div>
    </el-dialog>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
    <!-- 富文本预览 -->
    <rich-preview ref="rich"></rich-preview>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import PreviewVideo from "./components/preview-video";
import PreviewPicture from "./components/previewPicture";
import TagSelector from "@/components/tagSelector";
import RichPreview from "@/components/rich-preview/index.vue";
import API from "@/api";
import { sortEscape } from "@/utils/global";
import { maxTotalTypes, sortTypes, videoPermissionTypes } from "../../../config";
export default {
  components: {
    PreviewVideo,
    TagSelector,
    PreviewPicture,
    RichPreview
  },
  data() {
    return {
      time: [],
      imgUrl: baseConfig.imgUrl,
      newImgUrl: baseConfig.newImgUrl,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      videoPermissionTypes,
      // 列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        mVia: 0,
        start: null,
        end: null,
        sortType: null,
        videoType: 0,
        syncType: undefined,
        maxTotal: maxTotalTypes[0].value
      },
      uids: [],
      isSelection: false,
      isDisabled: false,
      multipleSelection: [],
      ids: [],
      // 表单验证规则
      // rules: {
      //     authorID: [{
      //         required: true,
      //         message: '请输入作者ID',
      //         trigger: 'blur'
      //     }, ]
      // },
      authorID: "",
      vloggerUserId: "",
      showVidUse: false,
      searchTitle: "",
      searchHashId: "",
      searchUpId: "",
      mViaList: [
        { label: "全部", value: 0 },
        { label: "up主", value: 1 },
        { label: "非up主", value: 2 },
      ],
      videoTypes: [
        {
          label: "长视频",
          value: 0,
        },
        {
          label: "短视频",
          value: 1,
        },
        {
          label: "图文",
          value: 2,
        },
      ],
      syncTypes: [
        {
          label: "全量",
          value: "all",
        },
        {
          label: "增量",
          value: "incr",
        },
      ],
      sortTypes,
      maxTotalTypes,
      tagList: [],
      tags: [],
      permission: null,
      reviewAt: null,
      coin: null,
      sections: [],
      subSections: [],
      searchSubSections: [],
      searchSectionId: "",
      searchSubSectionId: "",
    };
  },
  watch: {
    time(val) {
      if (val && val.length >= 2) {
        this.params.start = val[0]
        this.params.end = val[1]
      } else {
        this.params.start = null
        this.params.end = null
      }
    }
  },
  created() {
    this.getSections();
    this.getList();
  },
  methods: {
    getTagList() {
      if (this.tagList.length) return
      const params = {};
      API.queryTagList(params).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
    //查询专题列表数据
    getSections() {
      API.sectionList({}).then((res) => {
        if (res && res.code === 200) {
          this.sections = res.data;
        }
      });
    },
    // 请求列表
    getList(type) {
      this.loading = true;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.params.title = this.searchTitle || undefined;
      this.params.hash_id = this.searchHashId || undefined;
      this.params.vlogger_user_id = Number(this.searchUpId) || undefined;
      API.queryMediaResConfig(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            // console.log(this.tableData)
            this.tableData = res.data.list;
            this.tableData.forEach((i) => {
              i.tags_text = i.tags_text.split(",").slice(0, 3);
            });
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch((e) => {
          console.error(e);
          this.loading = false;
        });
    },
    searchSelectSection(val) {
      this.sections.forEach(i => {
        if (i.id == val) {
          this.searchSubSections = i.allSection;
        }
      })
      this.searchSubSectionId = "";
    },
    giveUp() {
      this.multipleSelection = [];
      this.ids = [];
      this.searchSubSectionId = "";
      this.searchSubSections = [];
      this.isDisabled = false;
      this.isSelection = false;
      this.$refs.multipleTable.clearSelection();
    },

    useVideo() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error("请选择使用视频资源");
        return;
      }
      this.getTagList();
      this.showVidUse = true;
      // this.$confirm("确认使用视频资源？")
      //     .then(() => {
      //         this.useMedia();
      //     })
      //     .catch(() => {});
    },
    // 图集预览
    previewPicture(pictureArr) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr);
    },
    async useMedia() {
      let arr = [];
      this.multipleSelection.forEach((i) => {
        arr.push(i.id);
      });
      // if (!this.authorID) {
      //     this.$message.error("请输入作者ID");
      //     return;
      // }
      // if (this.tags.length <= 0) {
      //     this.$message.error("请选择标签");
      //     return;
      // }
      let res = await API.useMediaRes({
        ids: arr,
        permission: this.permission,
        authorID: Number(this.authorID),
        sectionID: this.searchSubSectionId,
        reviewAt: this.reviewAt,
        coin: this.coin,
        // vlogger_user_id: Number(this.vloggerUserId),
        tags: this.tags,
        videoType: this.params.videoType,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "使用成功!",
        });
        this.multipleSelection = [];
        this.isSelection = false;
        this.isDisabled = false;
        this.showVidUse = false;
        this.getList();
        return;
      }
      this.$message.error("操作失败");
    },

    async ignoreMedia() {
      let arr = [];
      this.multipleSelection.forEach((i) => {
        arr.push(i.id);
      });

      let res = await API.ignoreMediaRes({
        ids: arr,
        videoType: this.params.videoType,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.multipleSelection = [];
        this.isSelection = false;
        this.isDisabled = false;
        this.getList();
        return;
      }
      this.$message.error("操作失败");
    },

    neglectVideo() {
      if (this.multipleSelection.length <= 0) {
        this.$message.error("请选择使用视频资源");
        return;
      }
      this.$confirm("确认忽略选中视频资源？")
        .then(() => {
          this.ignoreMedia();
        })
        .catch(() => { });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(val)
    },

    openSelection() {
      this.isSelection = true;
      this.isDisabled = true;
    },
    previewRich(text) {
      if (text) {
        this.$refs.rich.open(text)
      } else {
        this.$message.error('该视频暂无图文')
      }
    },

    // 数据排序
    handleSortChange(column) {
      this.params.value = sortEscape(column.order);
      this.params.key = column.prop;
      this.getList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 处理标签
    handleTag(row) {
      let tags = row.tags_text.split(",");
      return tags;
    },
    // 视频查看
    checkMedia(url, type, data) {
      // console.log(url, type, data)
      this.$refs.previewVideo.open(url, type, data);
    },
    // 取消
    cancelBtn() {
      this.showVidUse = false;
    },
    close() {
      this.showVidUse = false;
      this.authorID = "";
      this.vloggerUserId = "";
      this.tags = [];
    },
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl;
        } else {
          return this.imgUrl;
        }
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vid-res-box {
  .tagItem {
    margin: 0 5px 5px;
  }

  /deep/ .el-form-item__content {
    display: flex;
  }

  .param-input {
    width: 220px;
  }
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn {
  margin-top: 20px;
}

.picturePreview {
  max-width: 300px;
  display: flex;
}
</style>
